import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FormikProvider from '../../shared/forms/formikProvider.component';
import Modal from '../../shared/modals/modal.component';
import Form from '../../shared/forms/form.component';

import schema from './currencyConversionRateForm.schema';

import { CurrencyConversionRatePropTypes, CurrencyConversionRatesPropTypes } from '../../shared/propTypes/currencyConversionRate';
import { PeriodPropTypes } from '../../shared/propTypes/period';
import {
  hideCurrencyConversionRateModalForAddEdit,
  saveCurrencyConversionRate,
} from './store/actions';

import {
  isSavingInProgressSelector,
  currencyOptionsSelector,
  currencyConversionRatesSelector,
  fetchingCurrencyConversionRatesSelector,
} from './store/selectors';
import { OptionsPropType } from '../../shared/propTypes/common';

const ModalTitles = {
  ADD: 'Add Currency Conversion Rate',
  EDIT: 'Edit Currency Conversion Rate',
};

class AddCurrencyConversionRateModal extends PureComponent {
  static propTypes = {
    currencyConversionRates: CurrencyConversionRatesPropTypes,
    entityToEdit: CurrencyConversionRatePropTypes,
    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,
    currencyOptions: OptionsPropType,

    period: PeriodPropTypes.isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    isFetchingInitialData: PropTypes.bool.isRequired,

    openForEdit: PropTypes.bool,
    isVisible: PropTypes.bool,
  };

  save = (formData, { setSubmitting, resetForm }) => {
    const { period, saveEntity, openForEdit } = this.props;

    saveEntity({
      ...formData,
      periodName: period.name,
    }, openForEdit, { callback: resetForm });
    setSubmitting(false);
  };

  renderModal = ({ formik, schema }) => {
    const {
      openForEdit,
      currencyOptions,
      hideModal,
      isVisible,
      isSavingInProgress,
      isFetchingInitialData,
    } = this.props;

    const reset = () => {
      hideModal();
      formik.resetForm();
    };

    return (
      <Modal
        className="add-currency-conversion-rate-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset} // eslint-disable-line react/jsx-no-bind
        dismissText="Cancel"
        dismissAction={reset} // eslint-disable-line react/jsx-no-bind
        submitText="Save"
        submitAction={formik.handleSubmit}
        isSubmitting={formik.isSubmitting || isSavingInProgress}
        isVisible={isVisible}
        isLoading={isFetchingInitialData}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            currencyOptions,
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit, currencyConversionRates, openForEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.save}
        render={this.renderModal}
        validationContext={{
          entities: currencyConversionRates,
          openForEdit,
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  currencyOptions: currencyOptionsSelector(state),
  isSavingInProgress: isSavingInProgressSelector(state),
  currencyConversionRates: currencyConversionRatesSelector(state),
  isFetchingInitialData: fetchingCurrencyConversionRatesSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideModal: hideCurrencyConversionRateModalForAddEdit,
    saveEntity: saveCurrencyConversionRate,
  }
)(AddCurrencyConversionRateModal);
